// packages/api-client/src/services/admin/adminTransactionsService.ts
import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse, PaginatedResponse, AdminCreditTransactionItem } from '@dopomogai/types';

const ADMIN_TRANSACTIONS_PREFIX = '/admin/transactions/';

export const adminTransactionsService = {
  /**
   * Fetches a paginated list of all transactions across all users. Admin-only.
   */
  listAllTransactions: (params: { limit: number; offset: number }): ServiceResponse<PaginatedResponse<AdminCreditTransactionItem>> => {
    return getApiClient().get<PaginatedResponse<AdminCreditTransactionItem>>(ADMIN_TRANSACTIONS_PREFIX, { params })
      .then(res => res.data)
      .catch(err => handleApiError(err, 'listing all transactions'));
  },
};